module.exports = __webpack_public_path__ + "img/clover-green.aa4558f2.webp";